<mat-card>
  <form name="pricingForm" [formGroup]="form">
    <h3>Pricing</h3>
    <p>Is this event a free or paid event?</p>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-select required formControlName="admission" name="admission_price" aria-label="Adminssion Price">
            <mat-option *ngFor="let pricing of pricingModels" [value]="pricing.value">
              {{pricing.viewValue}}
            </mat-option>
          </mat-select>
          <mat-label>Admission Price</mat-label>
          <mat-error *ngIf="form.get('admission').invalid">{{getErrorMessage('admission')}}</mat-error>

          <mat-hint>Do people have to pay for the event?</mat-hint>
        </mat-form-field>

      </div>
    </div>

    <div class="row" *ngIf="form.get('admission').value && form.get('admission').value == 'paid'">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <input matInput formControlName="generalAdmissionPrice" type="number" aria-label="Event General Admission Price" name="event_general_admission_price" (focusout)="trimValue($event,'generalAdmissionPrice')">
          <mat-label>General Admission Price</mat-label>
          <mat-icon matSuffix>euro_symbol</mat-icon>
          <mat-hint>What is the general admission price?</mat-hint>
          <mat-error *ngIf="form.get('generalAdmissionPrice').invalid">{{getErrorMessage('generalAdmissionPrice')}}</mat-error>
        </mat-form-field>
      </div>
      <!-- <div class="col-6">
        <mat-form-field appearance="outline">
          <input matInput formControlName="highestAdmissionPrice" type="number" aria-label="Event Highest Admission Price" name="event_highest_admission_price" (focusout)="trimValue($event,'highestAdmissionPrice')">
          <mat-label>Highest Admission Price</mat-label>
          <mat-icon matSuffix>euro_symbol</mat-icon>
          <mat-hint>What is the maximum price of admission?</mat-hint>
          <mat-error *ngIf="form.get('highestAdmissionPrice').invalid">{{getErrorMessage('highestAdmissionPrice')}}</mat-error>
        </mat-form-field>
      </div> -->
    </div>
  </form>
</mat-card>